import { render } from "./AdminLeads.vue?vue&type=template&id=d7baf55e"
import script from "./AdminLeads.vue?vue&type=script&lang=js"
export * from "./AdminLeads.vue?vue&type=script&lang=js"

import "./AdminLeads.vue?vue&type=style&index=0&id=d7baf55e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__